import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { appReducer } from './app/app.slice';
import { locationsListParamsReducer } from './locations/locations-list.slice';
import { guestReducer } from './guest/guest.slice';
import { transactionsHistoryReducer } from './transactionsHistory/transactionsHistory.slice';
import { geoLocationReducer } from './geo-location/geo-location.slice';
import { locationsApi } from '../api/locations/locations.api';
import { stationsApi } from '../api/station/station.api';
import { setupModalReducer } from './setup-modal/setup-modal.slice';
import { transactionsApi } from '../api/transactions/transactions.api';

const rootReducer = combineReducers({
    appReducer,
    locationsListParams: locationsListParamsReducer,
    guest: guestReducer,
    transactionsHistory: transactionsHistoryReducer,
    geoLocation: geoLocationReducer,
    [locationsApi.reducerPath]: locationsApi.reducer,
    [stationsApi.reducerPath]: stationsApi.reducer,
    [transactionsApi.reducerPath]: transactionsApi.reducer,
    setupModal: setupModalReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            thunk: true,
        }).concat(locationsApi.middleware, stationsApi.middleware, transactionsApi.middleware),
});
